var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$root.windowWidth > 991)?_c('DesktopView'):_c('MobileView',{attrs:{"show-sidebar":_vm.showSidebar},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }